// extracted by mini-css-extract-plugin
export var editButton = "_oc-0";